export const scWalletSynthetixPerpV2LimitOrder = [
	{
		anonymous: false,
		inputs: [
			{ indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ indexed: false, internalType: 'bool', name: 'toDisable', type: 'bool' }
		],
		name: 'LogCancelLimitOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: true, internalType: 'address', name: 'market', type: 'address' }],
		name: 'LogSubmitCloseLimitOrder',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [{ indexed: true, internalType: 'address', name: 'market', type: 'address' }],
		name: 'LogSubmitLimitOrder',
		type: 'event'
	},
	{
		inputs: [
			{ internalType: 'uint256', name: 'orderId', type: 'uint256' },
			{ internalType: 'bool', name: 'toDisable', type: 'bool' }
		],
		name: 'cancelLimitOrder',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [],
		name: 'limitOrder',
		outputs: [{ internalType: 'contract ILimitOrder', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'name',
		outputs: [{ internalType: 'string', name: '', type: 'string' }],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{
				components: [
					{ internalType: 'bool', name: 'isUpper', type: 'bool' },
					{ internalType: 'uint256', name: 'triggerPrice', type: 'uint256' },
					{ internalType: 'uint256', name: 'limitPrice', type: 'uint256' },
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' }
				],
				internalType: 'struct ILimitOrder.Request',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'submitCloseLimitOrder',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	},
	{
		inputs: [
			{ internalType: 'address', name: 'market', type: 'address' },
			{
				components: [
					{ internalType: 'bool', name: 'isUpper', type: 'bool' },
					{ internalType: 'uint256', name: 'triggerPrice', type: 'uint256' },
					{ internalType: 'uint256', name: 'limitPrice', type: 'uint256' },
					{ internalType: 'int256', name: 'sizeDelta', type: 'int256' },
					{ internalType: 'uint256', name: 'priceImpactDelta', type: 'uint256' },
					{ internalType: 'uint256', name: 'expiry', type: 'uint256' }
				],
				internalType: 'struct ILimitOrder.Request',
				name: 'request',
				type: 'tuple'
			}
		],
		name: 'submitLimitOrder',
		outputs: [
			{ internalType: 'string', name: '_eventName', type: 'string' },
			{ internalType: 'bytes', name: '_eventParam', type: 'bytes' }
		],
		stateMutability: 'payable',
		type: 'function'
	}
];
